var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":_vm.size}},[(_vm.useCustomImage)?_c('v-img',{attrs:{"src":_vm.iconData}}):_vm._e(),(_vm.useGravatar)?_c('v-gravatar',{attrs:{"email":_vm.attr.email,"size":_vm.size}}):_vm._e(),(_vm.useDefaultIcon)?_c('font-awesome-icon',{attrs:{"icon":"user-circle","fixed-width":"","size":"2x"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }